// This import loads the firebase namespace along with all its type information.
import PlaywatchSettings from './playwatch-settings-model'

export async function load_playwatchSettingss(): Promise<PlaywatchSettings[]> {
  throw 'Not implemented'
}

export async function delete_playwatchSettings(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_playwatchSettings(): Promise<PlaywatchSettings> {
  throw 'Not implemented'
}
